import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
// Components
import ProjectCard from '../components/ProjectCard';
import MetricsCard from '../components/MetricsCard';
import TestimonialCard from '../components/TestimonialCard';
// CSS
import '../assets/css/home.css';
import '../assets/owl carousel/owl.carousel.min.css';
import '../assets/owl carousel/owl.theme.default.min.css';
// Images
import Header_Illustration from '../assets/images/header_illustration.svg';

export default function Home(props) {

  if(props.section === 'Services') {
    window.location.href = '/services#services';
  }

  return (
    <div className="home_page">
      <header>
        <div className="container">
          <div className="intro">
            <h1>Make Your<br />Imagination<br />Move On</h1>
            <div className='tagline'>Make Your Imagination Move On</div>
            <h2>Who we are?</h2>
            <p>We are the Software Development and Digital Marketing agency providing Web Development, App Development, Digital Marketing and other IT solution services.</p>
            
            <div className='actions select_n'>
              <Link to='/contact#contact' className='btn'>Contact</Link>
              <span>Or</span>
              <Link to='/about#about' className='btn'>Know About Us</Link>
            </div>
          </div>
          <div className="image">
            <img src={Header_Illustration} alt="Software Development and Digital Marketing Service" />
          </div>
        </div>
        <a href="#services" className="scroll-down"></a>
      </header>

      <div className='container'>
        <section className="services" id="services">
          <div className='section_header'>
            <span>All of our</span>
            <h2>Services</h2>
          </div>
          <div className="section_content">

            <div className="card">
              <div className="icon">
                <img src={require('../assets/images/service banners/web-development.png')} alt="Web Development" />
              </div>
              <h3 className="title">Web Development</h3>
              <p>We have top class Web Designers & Developers ready for your any kind of project.</p>

              <div className="actions">
                <Link to='/services#web-development' className='btn'>Read More  <i className="fa-solid fa-circle-arrow-right"></i></Link>
              </div>
            </div>

            <div className="card">
              <div className="icon">
                <img src={require('../assets/images/service banners/app-development.png')} />
              </div>
              <h3 className="title">App Development</h3>
              <p>Get your cross platfrom fluent android and ios app design and development from us.</p>

              <div className="actions">
                <Link to='/services#web-development' className='btn'>Read More  <i className="fa-solid fa-circle-arrow-right"></i></Link>
              </div>
            </div>

            <div className="card">
              <div className="icon">
                <img src={require('../assets/images/service banners/ecommerce-marketplace.png')} />
              </div>
              <h3 className="title">Ecommerce Marketplace</h3>
              <p>Move your business online and start selling with our eCommerce Platform.</p>

              <div className="actions">
                <Link to='/services#web-development' className='btn'>Read More  <i className="fa-solid fa-circle-arrow-right"></i></Link>
              </div>
            </div>

            <div className="card">
              <div className="icon">
                <img src={require('../assets/images/service banners/digital-marketing.png')} alt="Web Development" />
              </div>
              <h3 className="title">Digital Marketing</h3>
              <p>Get all type of marketing and SEO services from our digital marketing team.</p>

              <div className="actions">
                <Link to='/services#web-development' className='btn'>Read More  <i className="fa-solid fa-circle-arrow-right"></i></Link>
              </div>
            </div>

            <div className="card">
              <div className="icon">
                <img src={require('../assets/images/service banners/graphics-design.png')} />
              </div>
              <h3 className="title">Graphics Design</h3>
              <p>Design your imagination with us. We provide banner, logo, card designs and etc.</p>

              <div className="actions">
                <Link to='/services#web-development' className='btn'>Read More  <i className="fa-solid fa-circle-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </section>
        
        <section className='projects' id='projects'>
          <div className='section_header'>
            <span>Web Designs</span>
            <h2>Projects</h2>
          </div>
          
          <div className='section_content'>
            <div className='projects_container'>
              <OwlCarousel
                className='owl-theme'
                items={3}
                autoPlay={true}
                autoplayHoverPause={true}
                
                autoplaySpeed={1000}
                responsive={{
                  950: {items: 3},
                  600: {items: 2},
                  0: {items: 1}
                }}
                dots={true}
                margin={15}
              >
                <ProjectCard
                  banner={require('../assets/images/project banners/bildzeitschrift.png')}
                  title='bildZEITSchrift'
                  type='Magazine eCommerce Design'
                  link='https://bildzeitschrift.web.app/'
                />
                <ProjectCard
                  banner={require('../assets/images/project banners/codohov.png')}
                  title='CodoHov'
                  type='Edtech Platform'
                  link='https://codohovbd.web.app/'
                />
                <ProjectCard
                  banner={require('../assets/images/project banners/hovered-us.png')}
                  title='Hovered Us'
                  type='Social Media Platform'
                  link='https://hovered-us.web.app/'
                />
                <ProjectCard
                  banner={require('../assets/images/project banners/hovshop.png')}
                  title='HovShop'
                  type='eCommerce Website Design'
                  link='https://hovshopbd.web.app/'
                />
              </OwlCarousel>
            </div>
          </div>
        </section>

        <section className='metrics' id='metrics'>
          <div className='section_content m_n'>
            <MetricsCard
              title='Projects'
              count={'3700K+'}
            />
            
            <MetricsCard
              title='Happy Clients'
              count={'3500K+'}
            />

            <MetricsCard
              title='Awarads'
              count={'12'}
            />

            <MetricsCard
              title='Employees'
              count={'17'}
            />
          </div>
        </section>
      </div>
      
      <section className='hire'>
        <div className='container'>
          <div className='section_content'>
            <div className='left'>
              <h2>Have a project on your mind?</h2>
              <p>We are always ready to help you out with your project. Just send me your project details and contact information, We will check it out.</p>
              <Link to='/contact' className='btn'>Hire Us</Link>
            </div>

            <div className='right'>
              <img src={require('../assets/images/hire_illustration.png')} />
            </div>
          </div>
        </div>
      </section>

      <div className='container'>
        <section className='testimonials' id='testimonials'>
          <div className='section_header'>
            <span>What Our Clients Say</span>
            <h2>Testimonials</h2>
          </div>

          <div className='section_content'>
            <OwlCarousel
              className='owl-theme'
              items={4}
              autoPlay={true}
              autoplayHoverPause={true}
              
              autoplaySpeed={1000}
              responsive={{
                1050: {items: 4},
                850: {items: 3},
                520: {items: 2},
                0: {items: 1}
              }}
              dots={true}
              margin={15}
            >
              <TestimonialCard
                image='https://via.placeholder.com/150'
                name='John Doe'
                designation='CEO, XYZ Company'
                quote='I am very happy with the service provided by the team. They are very professional and responsive. I will defenitely hire them again.'
              />
              <TestimonialCard
                image='https://via.placeholder.com/150'
                name='John Doe'
                designation='CEO, XYZ Company'
                quote='I am very happy with the service provided by the team. They are very professional and responsive. I will defenitely hire them again.'
              />
              <TestimonialCard
                image='https://via.placeholder.com/150'
                name='John Doe'
                designation='CEO, XYZ Company'
                quote='I am very happy with the service provided by the team. They are very professional and responsive. I will defenitely hire them again.'
              />
              <TestimonialCard
                image='https://via.placeholder.com/150'
                name='John Doe'
                designation='CEO, XYZ Company'
                quote='I am very happy with the service provided by the team. They are very professional and responsive. I will defenitely hire them again.'
              />
              <TestimonialCard
                image='https://via.placeholder.com/150'
                name='John Doe'
                designation='CEO, XYZ Company'
                quote='I am very happy with the service provided by the team. They are very professional and responsive. I will defenitely hire them again.'
              />
            </OwlCarousel>
          </div>
        </section>
      </div>
    </div>
  )
}
